import { OptionProps } from "@base/utils/utils.type";
import { Autocomplete, TextField } from "@mui/material";
import React from "react";

import { ErrorMessage } from "./dropDown.styled";
import { Props } from "./dropDown.type";

type AutocompleteOption = {
  label: string;
  value: string;
};

type AutocompleteFieldProps = {
  fullWidth?: boolean;
  disabled?: boolean;
  label?: string;
  name?: string;
  placeholder?: string;
  color?: "primary" | "secondary";
  value?: AutocompleteOption | null;
  options: AutocompleteOption[];
  touched?: boolean;
  error?: boolean;
  defaultValue?: AutocompleteOption | null;
  disableClearable?: boolean;
  errorMessage?: string;
  onChange?: (
    event: React.ChangeEvent<{}>,
    value: AutocompleteOption | null
  ) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

const AutocompleteField = ({
  options,
  name,
  onChange,
  onBlur,
  errorMessage,
  touched,
  defaultValue,
  fullWidth,
  placeholder,
  disableClearable = false,
  label,
}: AutocompleteFieldProps) => {
  const customIsOptionEqualToValue = (
    option: OptionProps,
    value: OptionProps
  ) => option.value === value.value;

  const textFieldStyle = {
    fontFamily: "NotoSans-Medium",
    fontSize: 14,
  };

  return (
    <>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.label}
        onChange={onChange}
        fullWidth={fullWidth}
        value={defaultValue}
        disableClearable={disableClearable}
        isOptionEqualToValue={customIsOptionEqualToValue}
        renderInput={(params) => (
          <TextField
            {...params}
            style={textFieldStyle}
            placeholder={placeholder}
            name={name}
            label={label}
            onBlur={onBlur}
            error={!!(errorMessage && touched)}
            sx={{
              "& .MuiInputBase-input": {
                height: "auto",
              },
            }}
            InputLabelProps={{ children: null }} // Specify empty children
          />
        )}
      />
      {touched && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  );
};

export default AutocompleteField;
